import axios from 'axios'

import { buildUrl } from '@/services/path'
import Network from '@/services/network'

interface Namespace {
  id: string
  creationDate?: number
  deviceCount?: number
  deviceLimit?: number
  metadata?: Usage
  renewalDate?: number
}

interface Usage {
  count: number
}

/**
 * Fetches deployments for a given user.
 */
async function fetchDeployments() {
  const namespaces = await axios.get<{ value: Namespace[] }>(buildUrl(process.env.VUE_APP_BROKER_URL, '/api/v1/namespaces'))
    .then(resp => resp.data.value)
  for (const namespace of namespaces) {
    const nodes = await Network.nodes(namespace.id)
    for (const node of nodes) {
      if (node.metadata && node.metadata.usage && node.metadata.usage.count) {
        namespace.deviceCount = node.metadata.usage.count
        break
      }
    }
  }
  return namespaces
}

export {
  fetchDeployments
}
